(function () {
  // Le nouveau formulaire n'a plus d'ID.
  // On utilise uniquement une classe RSI stable.
  var FORM_SELECTOR = "form.rsi-form-main";

  var ENDPOINT = "https://api-new.3alla9ni.net/webhook/shopify/quick-form-abandoned";

  var hasSubmitted = false;

  // Déduplication session/page
  var sentKeys = {};

  // Déduplication persistante
  var LS_PREFIX = "__RSI_ABANDON_SENT__";

  function safeLSGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeLSSet(key, val) {
    try {
      window.localStorage.setItem(key, val);
    } catch (e) {}
  }

  function getShopifyDomain() {
    try {
      if (
        window.Shopify &&
        typeof window.Shopify.shop === "string" &&
        window.Shopify.shop.trim() !== ""
      ) {
        return window.Shopify.shop.trim();
      }
    } catch (e) {}

    return null;
  }

  // Récupère le nouveau formulaire via sa classe
  function getFormEl() {
    return document.querySelector(FORM_SELECTOR);
  }

  function formToObject(formEl) {
    var fd = new FormData(formEl);
    var obj = {};

    fd.forEach(function (v, k) {
      if (obj[k] !== undefined) {
        if (!Array.isArray(obj[k])) {
          obj[k] = [obj[k]];
        }

        obj[k].push(v);
      } else {
        obj[k] = v;
      }
    });

    return obj;
  }

  function shouldSend(formObj) {
    var phone = (
      formObj.phone ||
      formObj.telephone ||
      formObj.tel ||
      formObj.mobile ||
      ""
    ).toString().trim();

    return !!phone;
  }

  // Téléphone tunisien :
  // XXXXXXXX
  // ou +216XXXXXXXX
  function normalizePhone(raw) {
    return (raw || "")
      .toString()
      .replace(/[^\d+]/g, "")
      .trim();
  }

  function isPhoneComplete(raw) {
    var p = normalizePhone(raw);
    var digits = p.replace(/[^\d]/g, "");

    if (/^\+216\d{8}$/.test(p)) {
      return true;
    }

    if (/^\d{8}$/.test(digits)) {
      return true;
    }

    return false;
  }

  function getPhoneFromData(data) {
    return (
      data &&
      (
        data.phone ||
        data.telephone ||
        data.tel ||
        data.mobile ||
        ""
      )
    ) || "";
  }

  // Récupération des produits depuis le formulaire RSI
  function extractProductsFromModal() {
    var $ = window.jQuery;

    if (!$) {
      return [];
    }

    var $form = $(FORM_SELECTOR).first();

    if (!$form.length) {
      return [];
    }

    var items = [];

    $form.find("._rsi-modal-line-item").each(function () {
      var $it = $(this);

      var variantId =
        $it.attr("data-line-item-variant-id") || null;

      var title =
        (
          $it
            .find("a._rsi-modal-line-item-title")
            .text() || ""
        ).trim() || null;

      var qText =
        (
          $it
            .find("._rsi-modal-line-item-quantity")
            .text() || ""
        ).trim();

      var quantity = parseInt(qText, 10);

      if (!quantity || quantity < 1) {
        quantity = 1;
      }

      var price =
        (
          $it
            .find("._rsi-modal-line-item-final-price")
            .text() || ""
        ).trim() || null;

      var img =
        $it
          .find("img._rsi-modal-line-item-image")
          .attr("src") || null;

      items.push({
        variant_id: variantId,
        product_id: null,
        title: title,
        quantity: quantity,
        price: price,
        compare_at_price: null,
        image: img
      });
    });

    // Fallback : hidden inputs
    if (!items.length) {
      var formEl = getFormEl();

      if (formEl) {
        var data = formToObject(formEl);
        items = extractProductsFromHiddenInputs(data);
      }
    }

    return items;
  }

  function extractProductsFromHiddenInputs(data) {
    var variants = {};
    var qtys = {};

    Object.keys(data || {}).forEach(function (k) {
      var v = data[k];

      if (typeof k !== "string") {
        return;
      }

      if (k.indexOf("item_variant_id[") === 0) {
        var inner = k.substring(
          "item_variant_id[".length,
          k.length - 1
        );

        variants[inner] = v;
      }

      if (k.indexOf("item_quantity[") === 0) {
        var inner2 = k.substring(
          "item_quantity[".length,
          k.length - 1
        );

        qtys[inner2] = v;
      }
    });

    var out = [];

    Object.keys(variants).forEach(function (innerKey) {
      var variantId = variants[innerKey];

      var q = parseInt(
        qtys[innerKey] || "1",
        10
      );

      if (!q || q < 1) {
        q = 1;
      }

      out.push({
        variant_id: variantId
          ? String(variantId)
          : null,

        product_id: null,
        title: null,
        quantity: q,
        price: null,
        compare_at_price: null,
        image: null
      });
    });

    return out;
  }

  function buildPayload(formEl, reason) {
    var data = formToObject(formEl);

    return {
      shopify_domain: getShopifyDomain(),

      event: "form_abandoned",

      reason: reason || "phone_filled",

      occurred_at: new Date().toISOString(),

      page_url: window.location.href,

      referrer:
        document.referrer || null,

      user_agent:
        navigator.userAgent,

      // On n'a plus d'ID.
      // On envoie le sélecteur pour identifier le formulaire.
      form_id: null,
      form_selector: FORM_SELECTOR,

      abandoned_order_id:
        data.abandoned_order_id || null,

      country_code:
        data.country_code || null,

      cart_token:
        data.cart_token || null,

      data: data,

      products:
        extractProductsFromModal()
    };
  }

  function buildDedupKey(payload) {
    var shop =
      payload.shopify_domain ||
      "unknown_shop";

    var cart =
      payload.cart_token ||
      payload.abandoned_order_id ||
      "no_cart";

    var phone =
      normalizePhone(
        getPhoneFromData(payload.data)
      );

    return [
      LS_PREFIX,
      shop,
      cart,
      phone
    ].join("|");
  }

  function sendAbandon(payload) {
    var dkey =
      buildDedupKey(payload);

    // Déjà envoyé pendant cette page
    if (sentKeys[dkey]) {
      return;
    }

    // Déjà envoyé précédemment
    if (safeLSGet(dkey) === "1") {
      sentKeys[dkey] = true;
      return;
    }

    var body =
      JSON.stringify(payload);

    // Beacon en priorité
    if (navigator.sendBeacon) {
      try {
        var blob = new Blob(
          [body],
          {
            type:
              "text/plain;charset=UTF-8"
          }
        );

        var queued =
          navigator.sendBeacon(
            ENDPOINT,
            blob
          );

        // On marque comme envoyé uniquement
        // si sendBeacon a accepté la requête.
        if (queued) {
          sentKeys[dkey] = true;
          safeLSSet(dkey, "1");
          return;
        }

      } catch (e) {}
    }

    // Fallback fetch
    try {
      fetch(
        ENDPOINT,
        {
          method: "POST",

          mode: "no-cors",

          keepalive: true,

          headers: {
            "Content-Type":
              "text/plain;charset=UTF-8"
          },

          body: body
        }
      )
        .then(function () {
          sentKeys[dkey] = true;
          safeLSSet(dkey, "1");
        })
        .catch(function () {});

    } catch (e) {}
  }

  function trySend(reason) {
    var formEl =
      getFormEl();

    if (!formEl) {
      return;
    }

    if (hasSubmitted) {
      return;
    }

    var payload =
      buildPayload(
        formEl,
        reason
      );

    var phone =
      getPhoneFromData(
        payload.data
      );

    if (!isPhoneComplete(phone)) {
      return;
    }

    if (!shouldSend(payload.data)) {
      return;
    }

    sendAbandon(payload);
  }

  // Debounce téléphone
  var __phoneDebounceT = null;

  function hookPhoneWatcher() {
    var $ = window.jQuery;

    if (!$) {
      return;
    }

    var sel =
      FORM_SELECTOR + " input[name='phone'], " +
      FORM_SELECTOR + " input[name='telephone'], " +
      FORM_SELECTOR + " input[name='tel'], " +
      FORM_SELECTOR + " input[name='mobile'], " +
      FORM_SELECTOR + " input[type='tel']";

    $(document).on(
      "input change blur",
      sel,
      function () {

        if (__phoneDebounceT) {
          clearTimeout(
            __phoneDebounceT
          );
        }

        __phoneDebounceT =
          setTimeout(
            function () {
              trySend(
                "phone_filled"
              );
            },
            400
          );
      }
    );
  }

  function init() {
    var $ = window.jQuery;

    // Submit du nouveau formulaire
    $(document).on(
      "submit",
      FORM_SELECTOR,
      function () {
        hasSubmitted = true;
      }
    );

    hookPhoneWatcher();
  }

  function waitForJQAndInit() {
    var maxMs = 20000;
    var step = 200;
    var spent = 0;

    var t =
      setInterval(
        function () {

          if (
            typeof window.jQuery ===
            "function"
          ) {
            clearInterval(t);
            init();

          } else {

            spent += step;

            if (spent >= maxMs) {
              clearInterval(t);
            }
          }

        },
        step
      );
  }

  waitForJQAndInit();

  // ---------------------------
  // Méthodes de test console
  // ---------------------------

  window.__RSI_RESET_SESSION_SENT =
    function () {
      sentKeys = {};

      console.log(
        "[RSI] sentKeys reset (session/page only)"
      );
    };

  window.__RSI_SIMULATE_PHONE_FILLED =
    function () {
      trySend(
        "test_simulate_phone_filled"
      );
    };

  window.__RSI_CLEAR_DEDUP =
    function () {

      try {
        var keys = [];

        for (
          var i = 0;
          i < localStorage.length;
          i++
        ) {
          var k =
            localStorage.key(i);

          if (
            k &&
            k.indexOf(LS_PREFIX) === 0
          ) {
            keys.push(k);
          }
        }

        keys.forEach(
          function (k) {
            localStorage.removeItem(k);
          }
        );

        console.log(
          "[RSI] cleared dedup keys:",
          keys.length
        );

      } catch (e) {

        console.log(
          "[RSI] failed to clear dedup keys"
        );
      }
    };
})();